export default __webpack_public_path__ + "static/media/rtq-question3-chart.f6b04c86.jpg";